import { render } from "./ServiceCategories.vue?vue&type=template&id=2160af06&scoped=true&ts=true"
import script from "./ServiceCategories.vue?vue&type=script&lang=ts"
export * from "./ServiceCategories.vue?vue&type=script&lang=ts"

import "./ServiceCategories.vue?vue&type=style&index=0&id=2160af06&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2160af06"]])

export default __exports__